import services from '@/services.js'

export default {
  getWhitelabelConfigByOrganizationId: ({ commit }, organizationId) => {
    return new Promise((resolve, reject) => {
      services
        .getWhitelabelConfigByOrganizationId(organizationId)
        .then((response) => {
          resolve(response)
          commit('SET_WHITELABEL_CONFIG', response.data.data)
          commit('SET_IS_WHITELABEL_CONFIG_FRESH', true)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },
  getWhitelabelConfig: ({ commit }) => {
    return new Promise((resolve, reject) => {
      services
        .getWhitelabelConfig()
        .then((response) => {
          resolve(response)
          commit('SET_WHITELABEL_CONFIG', response.data.data)
          commit('SET_IS_WHITELABEL_CONFIG_FRESH', true)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },
}
